<template>
    <div>
        <b-alert :show="notification.show" :variant="notification.variant" v-html="notification.message"></b-alert>
    </div>
</template>

<script>
  export default {
    props: {
      notification: {
        type: Object
      }
    },

    data() {
      return {};
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Common/Notification.vue